import "../assets/less/index.less";
import React from "react";
import ReactDOM from "react-dom";
import BaseComponent from "./BaseComponent";

export function renderGoalTracker(element, goalRef, opts = {}) {
  ReactDOM.render(
    <BaseComponent goalRef={goalRef} opts={opts} />,
    element
  );
}

export { BaseComponent };
